/* eslint camelcase: 0 */
import { toOrderProps } from './order'
import { toUserProps } from './user'
import { Payment } from '@/infrastructure/network/Monitaro/schema/models'
import { IPaymentProps, EmptyPaymentPropsFactory } from '@/entities/Payment'

export const toPaymentProps = (props: Payment | null | undefined): IPaymentProps => {
  if (!props) {
    return EmptyPaymentPropsFactory()
  }

  const { id, order, hospital, user, user_id, hospital_id, order_id, amount, term, limit_at } = props

  return EmptyPaymentPropsFactory({
    id,
    order: toOrderProps(order),
    hospital,
    user: toUserProps(user),
    userId: user_id,
    hospitalId: hospital_id,
    orderId: order_id,
    amount,
    term,
    limitAt: limit_at
  })
}
